import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CutPanelInspectionEnvProvider } from './cut-panel-inspection.env.provider';
import {
  TREQUEST_ComponentTagDetails,
  TREQUEST_ComponentTagsListByBundleTag,
  TREQUEST_CutPanelInspectionAllTransactions,
  TREQUEST_GetCutPanelInspectionInfo,
  TREQUEST_SaveCutPanelInspectionInfo,
  TREQUEST_SaveToBeRectifiedReplacedComponents,
  TRESPONSE_ComponentTagsListByBundleTag,
  TRESPONSE_CutPanelInspectionAllTransactions,
  TRESPONSE_GetCutPanelInspectionInfo,
  TRESPONSE_SaveCutPanelInspectionInfo,
  TRESPONSE_SaveToBeRectifiedReplacedComponents,
  TTagInfo,
  TREQUEST_ComponentTagDetailsWithWipInfo,
  TRESPONSE_ComponentTagDetailsWithWipInfo,
  TRESPONSE_ComponentTagsListByMasterBundleTagCPM,
  TREQUEST_ComponentTagsListByMasterBundleTagCPM,
} from '@monorepo/types';

@Injectable({
  providedIn: 'root',
})
export class CutPanelInspectionDataProvider {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-type': 'application/json',
    }),
  };

  constructor(private http: HttpClient, private cutPanelInspectionEnvProvider: CutPanelInspectionEnvProvider) {}

  fetchCutPanelInspectionInfo(payload: TREQUEST_GetCutPanelInspectionInfo) {
    const URL = this.cutPanelInspectionEnvProvider.getEnvVar('FETCH_CUT_PANEL_INSPECTION_INFO');
    return this.http.post<TRESPONSE_GetCutPanelInspectionInfo>(URL, payload, this.httpOptions);
    // const res: TRESPONSE_GetCutPanelInspectionInfo = getLandingPageCounts;
    // return of(res);
  }

  fetchComponentTagDetails(payload: TREQUEST_ComponentTagDetails) {
    const URL = this.cutPanelInspectionEnvProvider.getEnvVar('FETCH_COMPONENT_TAG_DETAILS');
    return this.http.post<TTagInfo[]>(URL, payload, this.httpOptions);
  }

  fetchComponentTagDetailsWithWipInfo(payload: TREQUEST_ComponentTagDetailsWithWipInfo) {
    const URL = this.cutPanelInspectionEnvProvider.getEnvVar('FETCH_COMPONENT_TAG_DETAILS_WITH_WIP_INFO');
    return this.http.post<TRESPONSE_ComponentTagDetailsWithWipInfo>(URL, payload, this.httpOptions);
  }

  fetchComponentsListByMasterTag(payload: TREQUEST_ComponentTagsListByBundleTag) {
    const URL = this.cutPanelInspectionEnvProvider.getEnvVar('FETCH_COMPONENTS_LIST_BY_MASTER_TAG');
    return this.http.post<TRESPONSE_ComponentTagsListByBundleTag>(URL, payload, this.httpOptions);
    // const res: TRESPONSE_ComponentTagsListByBundleTag = getComponentsListByMasterTag;
    // return of(res);
  }

  fetchComponentsListByMasterTagCPM(payload: TREQUEST_ComponentTagsListByMasterBundleTagCPM) {
    const URL = this.cutPanelInspectionEnvProvider.getEnvVar('FETCH_COMPONENTS_LIST_BY_MASTER_TAG_CPM');
    return this.http.post<TRESPONSE_ComponentTagsListByMasterBundleTagCPM>(URL, payload, this.httpOptions);
  }

  updateCpiDetails(payload: TREQUEST_SaveToBeRectifiedReplacedComponents) {
    const URL = this.cutPanelInspectionEnvProvider.getEnvVar('UPDATE_INSPECTION_INFO');
    return this.http.post<TRESPONSE_SaveToBeRectifiedReplacedComponents>(URL, payload, this.httpOptions);
  }

  saveCpiDetails(payload: TREQUEST_SaveCutPanelInspectionInfo) {
    const URL = this.cutPanelInspectionEnvProvider.getEnvVar('SAVE_INSPECTION_DETAILS');
    return this.http.post<TRESPONSE_SaveCutPanelInspectionInfo>(URL, payload, this.httpOptions);
    // const res: TRESPONSE_SaveCutPanelInspectionInfo = getSaveCpiResponse;
    // return of(res);
  }

  completeInspection(payload: TREQUEST_SaveCutPanelInspectionInfo) {
    const URL = this.cutPanelInspectionEnvProvider.getEnvVar('COMPLETE_INSPECTION');
    return this.http.post<TRESPONSE_SaveCutPanelInspectionInfo>(URL, payload, this.httpOptions);
    // const res: TRESPONSE_SaveCutPanelInspectionInfo = getSaveCpiResponse;
    // return of(res);
  }

  fetchAllTransactionsData(payload: TREQUEST_CutPanelInspectionAllTransactions) {
    console.log({ payload });
    const URL = this.cutPanelInspectionEnvProvider.getEnvVar('FETCH_ALL_TRANSACTIONS_DATA');
    return this.http.post<TRESPONSE_CutPanelInspectionAllTransactions>(URL, payload, this.httpOptions);
    // const res: TRESPONSE_CutPanelInspectionAllTransactions = getAllTransactionsData;
    // return of(res);
  }
}
